import React from 'react';
import GraphViewer from './GraphViewer';

const AdminKnowledgeGraph = () => <GraphViewer />;

export default AdminKnowledgeGraph;
